import {getImage} from "../assets";


export enum PrizeGroupType {
  weekly,
  monthly,
  quarterly,
}

export interface PrizeGroup {
  name: string;
  id: PrizeGroupType;
  description: string;
}

export interface Prize {
  id: number;
  name: string;
  group: PrizeGroup;
  image: string;
  period: string;
  date?: string;
}

export const prizeGroups: PrizeGroup[] = [
  {
    id: PrizeGroupType.weekly,
    name: "Еженедельные",
    description: "Каждую неделю",
  },
  {
    id: PrizeGroupType.monthly,
    name: "Ежемесячные",
    description: "Каждый месяц",
  },
  {
    id: PrizeGroupType.quarterly,
    name: "Ежеквартальные",
    description: "Каждый квартал",
  },
];

export  const prizes: Prize[] = [
  {
    id: 1,
    period: "Февраль - Март",
    name: "1 сертификат Оzon <br/> Запас корма на&nbsp;1&nbsp;мес.",
    group: prizeGroups[0],
    image: getImage?.["pw1.png"],
    date: "2026-02-01 00:00:00",
  },
  {
    id: 2,
    period: "Апрель - Июнь",
    name: "Игровой набор<br/> для питомца победителя кошка/собака",
    group: prizeGroups[0],
    image: getImage?.["pw2.png"],
    date: "2026-04-01 00:00:00",
  },
  {
    id: 3,
    period: "Июль - Сентябрь",
    name: "1 сертификат Оzon <br/> Дозатор для создания пены",
    group: prizeGroups[0],
    image: getImage?.["pw3.png"],
    date: "2026-07-01 00:00:00",
  },
  {
    id: 4,
    period: "Октябрь - Декабрь",
    name: "1 сертификат Оzon <br/> Автоматическая поилка",
    group: prizeGroups[0],
    image: getImage?.["pw4.png"],
    date: "2026-10-01 00:00:00",
  },

  {
    id: 5,
    period: "Февраль - Март",
    name: "Сертификат Озон на&nbsp;10&nbsp;000&nbsp;рублей",
    group: prizeGroups[1],
    image: getImage?.["pm1.png"],
    date: "2026-02-01 00:00:00",
  },
  {
    id: 6,
    period: "Апрель - Июнь",
    name: "Фитнес-трекер",
    group: prizeGroups[1],
    image: getImage?.["pm2.png"],
    date: "2026-04-01 00:00:00",
  },
  {
    id: 8,
    period: "Июль - Сентябрь",
    name: "Запас корма на&nbsp;3&nbsp;месяца",
    group: prizeGroups[1],
    image: getImage?.["pm3.png"],
    date: "2026-07-01 00:00:00",
  },

  {
    id: 9,
    period: "Октябрь - Декабрь",
    name: "Сертификат Озон на&nbsp;10&nbsp;000&nbsp;рублей",
    group: prizeGroups[1],
    image: getImage?.["pm1.png"],
    date: "2026-10-01 00:00:00",
  },
  {
    id: 10,
    period: "Февраль - Март",
    name: "Сертификат на покупку товаров для своего питомца",
    group: prizeGroups[2],
    image: getImage?.["pq1.png"],
    date: "2026-02-01 00:00:00",
  },
  {
    id: 11,
    period: "Апрель - Июнь",
    name: "Сертификат на обустройство дома ​",
    group: prizeGroups[2],
    image: getImage?.["pq2.png"],
    date: "2026-04-01 00:00:00",
  },
  {
    id: 12,
    period: "Июль - Сентябрь",
    name: "Сертификат на путешествие",
    group: prizeGroups[2],
    image: getImage?.["pq3.png"],
    date: "2026-07-01 00:00:00",
  },
  {
    id: 13,
    period: "Октябрь - Декабрь",
    name: "Сертификат на активный отдых",
    group: prizeGroups[2],
    image: getImage?.["pq4.png"],
    date: "2026-10-01 00:00:00",
  },
];